<ng-template #colGroupTemplate>
  <colgroup *ngIf="!isWidthConfigSet">
    <col [style.width]="th.dwWidth" [style.minWidth]="th.dwWidth" *ngFor="let th of listOfDwThComponent">
  </colgroup>
  <colgroup *ngIf="isWidthConfigSet">
    <col [style.width]="width" [style.minWidth]="width" *ngFor="let width of dwWidthConfig">
  </colgroup>
</ng-template>
<ng-template #tableInnerTemplate>
  <div
    #tableHeaderElement
    *ngIf="dwScroll.x || dwScroll.y"
    class="ant-table-header"
    [ngStyle]="headerBottomStyle">
    <table
      [class.ant-table-fixed]="dwScroll.x"
      [style.width]="dwScroll.x">
      <ng-template [ngTemplateOutlet]="colGroupTemplate"></ng-template>
      <thead class="ant-table-thead" *ngIf="dwScroll.y">
        <ng-template [ngTemplateOutlet]="dwTheadComponent?.template"></ng-template>
      </thead>
    </table>
  </div>
  <div
    #tableBodyElement
    class="ant-table-body"
    [style.maxHeight]="dwScroll.y"
    [style.overflow-y]="dwScroll.y?'scroll':''"
    [style.overflow-x]="dwScroll.x?'auto':''">
    <table [class.ant-table-fixed]="dwScroll.x" [style.width]="dwScroll.x">
      <ng-template [ngTemplateOutlet]="colGroupTemplate"></ng-template>
      <thead class="ant-table-thead" *ngIf="!dwScroll.y">
        <ng-template [ngTemplateOutlet]="dwTheadComponent?.template"></ng-template>
      </thead>
      <ng-content></ng-content>
    </table>
  </div>
  <div class="ant-table-placeholder" *ngIf="(data.length==0)&&!dwLoading">
    <span *ngIf="!dwNoResult">{{ locale.emptyText }}</span>
    <ng-container *ngIf="dwNoResult">
      <ng-container *ngIf="isNoResultString; else noResultTemplate">{{ dwNoResult }}</ng-container>
      <ng-template #noResultTemplate>
        <ng-template [ngTemplateOutlet]="dwNoResult"></ng-template>
      </ng-template>
    </ng-container>
  </div>
  <div class="ant-table-footer" *ngIf="dwFooter">
    <ng-container *ngIf="isFooterString; else footerTemplate">{{ dwFooter }}</ng-container>
    <ng-template #footerTemplate>
      <ng-template [ngTemplateOutlet]="dwFooter"></ng-template>
    </ng-template>
  </div>
</ng-template>
<div
  class="ant-table-wrapper"
  [class.ant-table-empty]="data.length==0">
  <dw-spin
    [dwDelay]="dwLoadingDelay"
    [dwSpinning]="dwLoading">
    <div>
      <div
        class="ant-table"
        #tableMainElement
        [class.ant-table-fixed-header]="dwScroll.x || dwScroll.y"
        [class.ant-table-bordered]="dwBordered"
        [class.ant-table-large]="dwSize=='default'"
        [class.ant-table-middle]="dwSize=='middle'"
        [class.ant-table-small]="dwSize=='small'">
        <div class="ant-table-title" *ngIf="dwTitle">
          <ng-container *ngIf="isTitleString; else titleTemplate">{{ dwTitle }}</ng-container>
          <ng-template #titleTemplate>
            <ng-template [ngTemplateOutlet]="dwTitle"></ng-template>
          </ng-template>
        </div>
        <div class="ant-table-content">
          <ng-container *ngIf="dwScroll.x || dwScroll.y; else tableInnerTemplate">
            <div class="ant-table-scroll">
              <ng-template [ngTemplateOutlet]="tableInnerTemplate"></ng-template>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <dw-pagination
      *ngIf="dwShowPagination&&data.length"
      [dwInTable]="true"
      [dwShowSizeChanger]="dwShowSizeChanger"
      [dwPageSizeOptions]="dwPageSizeOptions"
      [dwShowQuickJumper]="dwShowQuickJumper"
      [dwHideOnSinglePage]="dwHideOnSinglePage"
      [dwShowTotal]="dwShowTotal"
      [dwSize]="(dwSize=='middle'||dwSize=='small')?'small':''"
      [dwPageSize]="dwPageSize"
      (dwPageSizeChange)="emitPageSize($event)"
      [dwTotal]="dwTotal"
      [dwSimple]="dwSimple"
      [dwPageIndex]="dwPageIndex"
      (dwPageIndexChange)="emitPageIndex($event)">
    </dw-pagination>
  </dw-spin>
</div>